module.exports = __webpack_public_path__ + "img/ad.b5303ec7.png";